import "./SupportRuleManagement.css";
import { useNavigate } from "react-router-dom";
import uploadruleIcon from "../../../common/assets/images/uploadfile.png";
import viewruleIcon from "../../../common/assets/images/viewrdatabase.png";
import createruleIcon from "../../../common/assets/images/createnew.png";
import testruleIcon from "../../../common/assets/images/testdatabase.png";
import archievruleIcon from "../../../common/assets/images/archiveview.png";
import accessmanagementIcon from "../../../common/assets/images/mangementaccess.png";


const MODULE_CARDS = [
  {
    id: "view-rule-database",
    icon: viewruleIcon,
    title: "View Rule Database",
    description: "View, search, filter and manage existing rules.",
    path: "/view-rule-database",
    featured: true, // matches the highlighted/active card in the design
  },
  {
    id: "create-new-rule",
    icon: createruleIcon,
    title: "Create New Rule",
    description: "Create a new guidance and decision support rule.",
    path: "/create-new-rule", 
  },
  {
    id: "test-rules",
    icon: testruleIcon,
    title: "Test Rules",
    description: "Test rules against scenarios and validate rule behaviour.",
    path: "/test-rule-table",
  },
  {
    id: "view-archived-rules",
    icon: archievruleIcon,
    title: "View Archived Rules",
    description: "View and manage archived rules.",
    path: "/archived-rule", 
  },
  // {
  //   id: "access-management",
  //   icon: accessmanagementIcon,
  //   title: "Access Management",
  //   description: "Manage users, roles and permissions for rule management.",
  //   path: "/assist/guidance-decision-support/access-management", // 👈 update path
  // },
  // {
  //   id: "upload-file",
  //   icon: uploadruleIcon,
  //   title: "Upload File",
  //   description: "Upload rule data using a template or file.",
  //   path: "/assist/guidance-decision-support/upload-file", // 👈 update path
  // },
];

function ModuleTile({ icon, title, description, onClick }) {
  return (
    <button type="button" className="ruleMgmtHome-tile" onClick={onClick}>
      <div className="ruleMgmtHome-tile-icon">
        {icon && <img src={icon} alt={title} className="ruleMgmtHome-tile-icon-img" />}
      </div>
      <div className="ruleMgmtHome-tile-title">{title}</div>
      <p className="ruleMgmtHome-tile-desc">{description}</p>

      <span className="ruleMgmtHome-tile-chevron" aria-hidden="true">
        &#8250;
      </span>
    </button>
  );
}

export default function SupportRuleManagement() {
  const navigate = useNavigate();

  return (
    <div className="ruleMgmtHome-page">
      <h1 className="ruleMgmtHome-title">
        Guidance & Decision Support Rule Management
      </h1>
      <p className="ruleMgmtHome-subtitle">
        Create, test, maintain and manage the guidance and decision support
        rules to enhance coder experience and strengthen coding pathways.
      </p>

      <div className="ruleMgmtHome-divider" />

      <div className="ruleMgmtHome-grid">
        {MODULE_CARDS.map((card) => (
          <ModuleTile
            key={card.id}
            icon={card.icon}
            title={card.title}
            description={card.description}
            onClick={() => navigate(card.path)}
          />
        ))}
      </div>
    </div>
  );
}